/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep, get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { modifyWorkHistoryCommuteAdmin } from '../../../apis/work-history';
import Form from '../../../components/Form';
import Modal, { ModalHeader } from '../../../components/Modal';
import useForm from '../../../hooks/useForm';
import { dateToFormat, dateToViewFormat, diffSeconds, formatHourSecond } from '../../../utils/date';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';

const CommuteTimeManager = ({ open, setOpen, historyData, setHistoryData, submit }) => {
  const { employees } = useSelector(
    (store) => ({
      employees: store.Data.employees,

    }),
  );

  const [fields] = useState([
    [
      {
        title: "출근일시",
        key: "commuteStartDate",
        type: "datepicker",
        required: true,
      },
      {
        key: "commuteStartTime",
        type: "timepicker",
        required: true,

      },
    ],
    [
      {
        title: "퇴근일시",
        key: "commuteEndDate",
        type: "datepicker",
        required: true,
      },
      {
        key: "commuteEndTime",
        type: "timepicker",
        required: true,
      }
    ]
  ])

  const defaultForm = {
    commuteStartDate: '',
    commuteStartTime: '',
    commuteEndDate: '',
    commuteEndTime: '',
  }

  const _submit = (form) => {
    let _form = cloneDeep(form)
    _form = {
      commuteStartTime: `${form.commuteStartDate[0]} ${form.commuteStartTime}`,
      commuteEndTime: `${form.commuteEndDate[0]} ${form.commuteEndTime}`,
    }

    if(isEmpty(form.commuteStartDate[0]) || isEmpty(form.commuteStartTime)) {
      return toast.error('출근일시 필수입니다.')
    }
    if(isEmpty(form.commuteEndDate[0]) || isEmpty(form.commuteEndTime)) {
      return toast.error('퇴근일시 필수입니다.')
    }

    if (diffSeconds(_form.commuteStartTime, _form.commuteEndTime) <= 0) return toast.error('퇴근시간은 출근시간 이후로 설정해주세요.')

    const historyIdx = get(historyData, '[0].idx')
    systemAlert('해당 사용자의 출퇴근 기록을 수정하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '수정',
          onClick: () => {
            modifyWorkHistoryCommuteAdmin(historyIdx, _form)
              .then(() => {
                submit()
                cancel()
              })
          }
        }
      ]
    })
  }

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    if (!isEmpty(historyData)) {
      const _form = {
        commuteStartDate: dateToFormat(historyData[0].commuteStartTime) || dateToFormat(historyData[0].workDate),
        commuteEndDate: dateToFormat(historyData[0].commuteEndTime) || dateToFormat(historyData[0].workDate),
        commuteStartTime: dateToFormat(historyData[0].commuteStartTime, formatHourSecond) || '09:00:00',
        commuteEndTime: dateToFormat(historyData[0].commuteEndTime, formatHourSecond) || '18:00:00',
      }
      setForm(_form)
      setOriginForm(_form)
    } else {
      setForm(defaultForm)
      setOriginForm(defaultForm)
    }
  }, [open, historyData])

  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  const cancel = () => {
    setOpen(false)
    setHistoryData([])
  }

  const getTitle = () => {
    const data = historyData[0]
    const employeeName = employees.find((employee) => employee.idx === data.employeeIdx).name

    return (
      `${employeeName}님 (${dateToViewFormat(data.workDate)}) 출퇴근 기록 수정`
    )
  }

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="commute-time-manager">
        <ModalHeader>{getTitle()}</ModalHeader>
        <Form
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  )
}

export default CommuteTimeManager;